<template>
  <v-content>
    <v-form @submit="login">
      <v-card class="pa-5 ma-auto mt-10" max-width="35rem" :loading="loggingIn">
        <!-- <v-select
          :items="environmentOptions"
          v-model="selectedEnvironment"
          label="Environment"
          dense
          outlined
        ></v-select>-->
        <v-text-field name="name" label="Username" id="username" v-model="username"></v-text-field>
        <v-text-field type="password" label="Password" v-model="password"></v-text-field>

        <v-card-actions class="px-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" type="submit">Continue</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-content>
</template>

<script>
import Authentication from "../auth";
import EventBus from "../utility/Eventbus";
export default {
  name: "Login",
  data() {
    return {
      environmentOptions: ["DEV", "PROD"],
      selectedEnvironment: "DEV",
      loggingIn: false,
      password: "",
      username: "",
    };
  },
  methods: {
    async login(e) {
      e.preventDefault();
      this.loggingIn = true;
      try {
        const login = await Authentication.login(
          this.username,
          this.password,
          this.selectedEnvironment
        );
        if (login) {
          EventBus.$emit("login", true);
          this.goTo("/");
        }
      } catch (err) {
        EventBus.$emit("snackbar", err.message);
      }
      this.loggingIn = false;
    },
    goTo(path) {
      this.$route.path !== path && this.$router.push({ path });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
